module.exports = __webpack_public_path__ + "img/available.c318bf69.svg";